function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import epoch from '../lib/epoch.js';
import isObject from '../lib/is_object.js';
import secs from '../lib/secs.js';
export var ProduceJWT = /*#__PURE__*/function () {
  function ProduceJWT(payload) {
    _classCallCheck(this, ProduceJWT);

    if (!isObject(payload)) {
      throw new TypeError('JWT Claims Set MUST be an object');
    }

    this._payload = payload;
  }

  _createClass(ProduceJWT, [{
    key: "setIssuer",
    value: function setIssuer(issuer) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        iss: issuer
      });
      return this;
    }
  }, {
    key: "setSubject",
    value: function setSubject(subject) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        sub: subject
      });
      return this;
    }
  }, {
    key: "setAudience",
    value: function setAudience(audience) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        aud: audience
      });
      return this;
    }
  }, {
    key: "setJti",
    value: function setJti(jwtId) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        jti: jwtId
      });
      return this;
    }
  }, {
    key: "setNotBefore",
    value: function setNotBefore(input) {
      if (typeof input === 'number') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          nbf: input
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          nbf: epoch(new Date()) + secs(input)
        });
      }

      return this;
    }
  }, {
    key: "setExpirationTime",
    value: function setExpirationTime(input) {
      if (typeof input === 'number') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          exp: input
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          exp: epoch(new Date()) + secs(input)
        });
      }

      return this;
    }
  }, {
    key: "setIssuedAt",
    value: function setIssuedAt(input) {
      if (typeof input === 'undefined') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          iat: epoch(new Date())
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          iat: input
        });
      }

      return this;
    }
  }]);

  return ProduceJWT;
}();